import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { RICH_TEXT_OPTIONS } from 'consts/contentful';
import type { IngredientsEntry } from 'schema';
import { Ingredients, INGREDIENTS } from '.';

export const ContentfulIngredients = ({
  body,
  disclaimerText,
  skincareConcern,
  ...props
}: IngredientsEntry) => (
  <Ingredients
    ingredients={INGREDIENTS[skincareConcern]}
    body={body && documentToReactComponents(body, RICH_TEXT_OPTIONS)}
    disclaimerText={
      disclaimerText &&
      documentToReactComponents(disclaimerText, RICH_TEXT_OPTIONS)
    }
    {...props}
  />
);
